import React, { Component } from 'react';
import ReactHighcharts from 'react-highcharts';
import { cloneDeep } from 'lodash';
import { injectIntl } from 'react-intl';
import { iFMessage, FMessage } from '../../hoc/IntlComponents';
import Card from '../Card/Card';
import raw_data from './TargetAudience/chartData';
import chartColors from './TargetAudience/chartColors';
import chartBaseConfig from './TargetAudience/chartBaseConfig';

const { title, chart, series, ...rest } = chartBaseConfig;

const sorting = ['geo', 'demography', 'sources'];

class OfferTargetAudience extends Component {
  getChartConfig = ({ h, config }) => {
    const { intl } = this.props;
    return {
      chart: {
        ...chart,
        height: h,
      },
      title: {
        ...title,
        text: iFMessage({ intl, id: `offer.target-audience.chart.title.${config.settings.title}` }),
      },
      series: [
        {
          ...series,
          data: config.data,
        },
      ],
      ...rest,
    };
  };

  renderAudienceStats = ({ audience, audienceStats }) => {
    const charts = [];

    audienceStats.forEach(key => {
      const chartData = cloneDeep(raw_data);

      let h = 260;

      h += (Object.keys(audience[key]).length + 2) * 19;

      Object.keys(audience[key]).forEach(valKey => {
        const valData = audience[key][valKey];
        chartData[key].data.push({
          name: valKey,
          y: valData,
          color: chartColors[valKey] || null,
        });
      });

      charts.push(
        <ReactHighcharts
          domProps={{
            id: `target-audience_${key}`,
            className: 'target-audience-chart-pie',
          }}
          key={key}
          config={this.getChartConfig({ h, config: chartData[key] })}
          ref={`target-audience_${key}`}
        />,
      );
    });

    return charts;
  };

  sortStats = stats => stats.sort((a, b) => sorting.indexOf(a) - sorting.indexOf(b));

  render() {
    const audience = JSON.parse(this.props.audience);
    const audienceStats = this.sortStats(Object.keys(audience));

    if (!audienceStats || !audienceStats.length) {
      return null;
    }

    return (
      <Card className="offer-target-audience">
        <Card.Header>
          <FMessage id="offer.target-audience.title" />
        </Card.Header>
        <Card.Body className="target-audience-chart-wrapper">
          {this.renderAudienceStats({ audience, audienceStats })}
        </Card.Body>
      </Card>
    );
  }
}

export default injectIntl(OfferTargetAudience);
